export default "/assets/webpack-assets/hero-voucher-redeem.be0603d3e55a882ad513cf3d0ee2bda7.jpg";